import { theme } from "themes/default/theme"

export const styles = {
  dialogContent: {
    maxWidth: 800,
    width: `calc(100% - 10px)`,
    pb: 3.5,
  },
  actionButton: (theme) => ({
    textTransform: "none",
    color: theme.palette.common.black,
    opacity: 0.5,
    "&:hover": {
      textDecoration: "underline",
    },
  }),
  actionButtonRecording: (theme) => ({
    color: theme.palette.primary.main,
    animation: "animation_pulse linear 1.5s infinite",
  }),
  actionButtonRecorded: (theme) => ({
    backgroundColor: theme.palette.primary.main,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  }),
  submitButton: {
    textTransform: "none",
  },
  messageHeader: (theme) => ({
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  }),
  messageHeaderCenter: {
    textAlign: "center",
  },
  closeButton: (theme) => ({
    position: "absolute",
    right: 12,
    top: 8,
    color: theme.palette.common.black,
    p: 0,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "rotate(90deg) scale(1.3)",
    },
  }),
  dialogActions: {
    pr: 3.5,
  },
  input: (theme) => ({
    minHeight: 250,
    p: 0,
    outline: "none",
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 1.5,
    "& label.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "transparent",
      },
    },
    "& textarea": {
      // minHeight: 250,
      fontSize: 25,
      overflow: "auto",
      mt: 0.5,
      lineHeight: 1.15,
    },
  }),
  loaded: {
    fontSize: 12,
    color: theme.palette.grey[500],
    fontStyle: "italic",
  },
  gradeInput: (theme) => ({
    width: 75,
    borderRadius: 1.5,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.common.white,
    "& .MuiInputBase-readOnly": {
      backgroundColor: theme.palette.grey[100],
      border: `1px solid ${theme.palette.grey[300]}`,
    },
    "& .MuiInputBase-input": {
      width: 75,
      p: 0.625,
      textAlign: "center",
      color: theme.palette.primary.main,
      // remove arrows
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "&[type=number]": {
        "-moz-appearance": "textfield",
      },
    },
  }),
  grades: (theme) => ({
    p: 1.875,
    borderRadius: 2.5,
    backgroundColor: "#eeeeee",
    border: `1px solid #dddddd`,
  }),
}
